export default class Types {
  static APP = {
    version: '6.0.0',
    axbi: 'Copyright © 2023 Ax - BI Sistemas.',
    mobioh: 'Copyright © 2023 Mobioh Sistemas.',
    tituloMobioh: 'Mobioh - BI',
    tituloAxbi: 'Ax - BI',
    banner: 'https://imgs.lojainstantanea.com.br/mercasimples/geral/bi/07-enxergue-alem-das-planilhas.webp'
  }

  static INFINITE = {
    url: 'https://infinite-bi.mobioh.com.br',
    rodape: 'Copyright © 2023 Infinite - BI Sistemas.',
    titulo: 'Infinite - BI',
    logo: 'https://www.imgs.lojainstantanea.com.br/mercasimples/geral/bi/09_infinite_seg_bi_logo_20250729001.webp',
    banner:
      'https://www.imgs.lojainstantanea.com.br/mercasimples/geral/bi/09_infinite_seg_bi_banner_20250729001.webp',
  }

  static AXBI = {
    url: 'https://ax-bi.mobioh.com.br',
    titulo: 'Ax - BI',
    rodape: 'Copyright © 2023 Ax - BI Sistemas.',
    banner:
      'https://www.imgs.lojainstantanea.com.br/mercasimples/geral/bi/10_ax_seg_bi_banner_20250729001.webp',
    logo: 'https://www.imgs.lojainstantanea.com.br/mercasimples/geral/bi/10_ax_seg_bi_logo_branco_20250729001.webp',
  }

  static R3_SUPRIMENTOS = {
    url: 'https://r3suprimentos.mobioh.com.br',
    titulo: 'R3 Suprimentos',
    rodape: 'Copyright © 2026 Mobioh Sistemas.',
    banner: '',
    logo: 'https://media.licdn.com/dms/image/v2/C4E0BAQGmrQd9WlZrRQ/company-logo_200_200/company-logo_200_200/0/1630587611338/r3suprimentos_logo?e=2147483647&v=beta&t=3jL20SC49uPj60w12BmJOkNDt2hlLRj1QFDiZ5wy-eY',
  }
}
